var _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerticallines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3,
    height: 34,
    viewBox: "0 0 3 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1.37415,
    y1: 33.8281,
    x2: 1.37415,
    y2: 0.642689,
    stroke: "#3FAC64",
    strokeWidth: 2.42748
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticallines);
export default __webpack_public_path__ + "static/media/verticallines.976b52b7c4e7bf9f3e9bba547efc54e4.svg";
export { ForwardRef as ReactComponent };